export { default as ProductComparisonTable } from './ProductComparisonTable';
